import { RoomOption } from '@/v2/types/ui';

const getIsMaxOccupantsExceeded = (
  rooms: RoomOption[] | undefined | null,
  travellers: number,
) =>
  !!rooms
    ?.map((room) => room?.roomType?.maxOccupants || 0)
    .every((maxOccupants) => maxOccupants < travellers);

export default getIsMaxOccupantsExceeded;
